import { useState, useEffect } from 'react';

// Alternate URL: swap /uploads-cache/ <-> /uploads so the browser can render
// the photo even if the cached copy was pruned (or the S3 mount is stale).
function altUrl(url) {
  if (typeof url !== 'string') return null;
  if (url.includes('/uploads-cache/')) return url.replace('/uploads-cache/', '/uploads/');
  if (url.includes('/uploads/')) return url.replace('/uploads/', '/uploads-cache/');
  return null;
}

/**
 * <img> that automatically retries with the alternate /uploads<->/uploads-cache
 * URL when the first one fails to load.
 */
export default function FailoverImg({ src, alt = '', className = '', onClick = null }) {
  const [current, setCurrent] = useState(src);
  useEffect(() => setCurrent(src), [src]);

  return (
    <img
      src={current}
      alt={alt}
      className={className}
      onClick={onClick}
      onError={() => {
        const fallback = altUrl(src);
        if (fallback && current !== fallback) setCurrent(fallback);
      }}
    />
  );
}
